import { CURRENT_PAYMENT_APP_VERSION } from '../../config/constants';
import { useFlag } from '../../services/launchDarkly';
import type { SystemErrorCodes } from '../../stores/app/types';

import { ExternalPaymentsV2 as V2Component } from './v2/ExternalPayments';
import { ExternalPaymentsV4 as V4Component } from './v4/ExternalPayments';
import { ExternalPaymentsV5 as V5Component } from './v5/ExternalPayments';

/** Crown Rips ship-card context forwarded to the payments app (packageType=shipping). */
export interface ShipCardParams {
  providerItemIds: string[];
  cardName?: string;
  cardSubtitle?: string;
  cardImageUrl?: string;
  /** The game's launch session token — auth for the rips-api shipping endpoints. */
  sessionId?: string;
}

export function ExternalPayments(props: {
  paymentMethod?: string;
  errorCode?: SystemErrorCodes;
  errorDetails?: string;
  presetIframeParams?: string;
  storeType: 'store' | 'mini-store' | 'subscription';
  // Opens the payments app on its deposit ("Add cash") screen instead of the order summary.
  isDeposit?: boolean;
  // Opens the payments app on the Crown Rips "Ship Card" screen with this shipment context.
  shipping?: ShipCardParams;
}) {
  const version = useFlag<number>('payments_app_version', CURRENT_PAYMENT_APP_VERSION);

  switch (version) {
    case 5:
      return <V5Component isDeposit={props.isDeposit} shipping={props.shipping} storeType={props.storeType} />;
    case 4:
      return <V4Component isDeposit={props.isDeposit} shipping={props.shipping} storeType={props.storeType} />;
    default:
      return <V2Component {...props} />;
  }
}
